import type { SearchResultType } from '../types';

export const getResultLink = (
  type: SearchResultType,
  id: string,
  blockIds?: string[],
  highlightTerms?: string[],
): string => {
  const searchParams = new URLSearchParams();
  if (blockIds?.length && (type === 'submissions' || type === 'templates')) {
    searchParams.set('blockIds', blockIds.join(','));
  }
  if (highlightTerms?.length) {
    searchParams.set('highlight', highlightTerms.join('|'));
  }

  switch (type) {
    case 'submissions':
      return `/contracts/${id}/contract?${searchParams.toString()}`;
    case 'templates':
      return `/templates/${id}/contract?${searchParams.toString()}`;
    case 'clauses':
      return `/clauses/${id}?${searchParams.toString()}`;
    case 'blocks':
      return `/blocks/${id}?${searchParams.toString()}`;
  }
};
